import styled from 'styled-components';

export const TokenPurchaseEntryContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  padding: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.3);
  }
`;
export const LeftContent = styled.div`
    align-items: center;
    display: flex;
    gap: 16px;
`
export const DateDisplay = styled.h4`
    color: #FFFFFF;
    border: 1px solid #FFFFFF;
    border-radius: 4px;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    font-weight: 600;
    padding: 8px 8px;
    text-align: center;
    width: 160px;
`
export const ActionDisplay = styled.h4`
    color: #FFFFFF;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
`
export const TokenCountDisplay = styled.div`
    align-items: center;
    display: flex;
    gap: 8px;

    img {
        height: 16px;
    }

    span {
        color: #FFFFFF;
    }
`;

export const TokenCount = styled.div`
    align-items: center;
    display: flex;
    gap: 8px;
  
  img {
    width: 24px;
    height: 24px;
  }
`;

export const TokenPurchaseAmount = styled.div`
  text-align: center;
  margin: 0 20px;
  
  h4 {
    color: #4CAF50;
    margin: 0;
    font-size: 18px;
    font-weight: 700;
  }
`; 